"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeHxLocationEntityDataArgs = void 0;
var HxLocationIdDataArgs_1 = require("./HxLocationIdDataArgs");
function serializeHxLocationEntityDataArgs(_arg) {
    var output = [];
    output.push(_arg.displayName);
    output.push(_arg.streetAddress);
    output.push(_arg.city);
    output.push(_arg.state);
    output.push(_arg.country);
    output.push(_arg.postalCode);
    output.push(_arg.latitude);
    output.push(_arg.longitude);
    output.push(_arg.accuracy);
    output.push(_arg.locationUri);
    output.push(_arg.locationSource);
    output.push(_arg.locationIdData !== undefined);
    if (_arg.locationIdData !== undefined) {
        output.push(HxLocationIdDataArgs_1.serializeHxLocationIdDataArgs(_arg.locationIdData));
    }
    return output;
}
exports.serializeHxLocationEntityDataArgs = serializeHxLocationEntityDataArgs;
